import {createFileRoute} from '@tanstack/react-router';

import {CreateSiteForm} from '@/features/Site/components/CreateSiteForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/sites/create')({
  component: CreateSiteForm,
  beforeLoad: () => makeDocumentTitle(`Create Site`),
});
